import { render, staticRenderFns } from "./PartnerWorkerForm.vue?vue&type=template&id=e064cb8c&scoped=true&"
import script from "./PartnerWorkerForm.vue?vue&type=script&lang=js&"
export * from "./PartnerWorkerForm.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWorkerForm.vue?vue&type=style&index=0&id=e064cb8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e064cb8c",
  null
  
)

export default component.exports